var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.slide.html)}}),_vm._l((_vm.buttons),function(button){return _c('a',{staticClass:"button",attrs:{"href":"#"},on:{"click":button.action}},[_vm._v(_vm._s(button.text))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }